7// Babel helper functions.
// This is to deal with otherwise replicated code.

module.exports.interopRequireDefault = function interopRequireDefault(obj) {
	return obj && obj.__esModule ? obj : { default: obj };
}

module.exports.typeof = function _typeof(obj) {
	if (typeof Symbol == 'function' && typeof Symbol.iterator == 'symbol') {
		module.exports.typeof = function _typeof(obj) {
			return typeof obj;
		}
	} else {
		module.exports.typeof = function _typeof(obj) {
			return obj && typeof Symbol == 'function' && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj;
		}
	}

	return module.exports.typeof(obj);
}

if (typeof Reflect !== 'undefined' && Reflect.get) module.exports.get = Reflect.get;
else module.exports.get = function _get(target, property, receiver) {
	var base = module.exports.superPropBase(target, property);
	if (!base) return;
	var desc = Object.getOwnPropertyDescriptor(base, property);
	if (desc.get) return desc.get.call(receiver);
	return desc.value;
}

module.exports.superPropBase = function _superPropBase(object, property) {
	while (!Object.prototype.hasOwnProperty.call(object, property)) {
		object = module.exports.getPrototypeOf(object);
		if (object === null) break;
	}
	return object;
}

module.exports.defineProperty = function _defineProperty(obj, key, value) {
	if (key in obj) {
		Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	} else {
		obj[key] = value;
	}
	return obj;
}

module.exports.possibleConstructorReturn = function _possibleConstructorReturn(self, call) {
	if (call && (module.exports.typeof(call) == 'object' || typeof call == 'function')) {
		return call;
	}
	return module.exports.assertThisInitialized(self);
}

module.exports.assertThisInitialized = function _assertThisInitialized(self) {
	if (self === void 0) {
		throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	}
	return self;
}

if (Object.setPrototypeOf) module.exports.getPrototypeOf = Object.getPrototypeOf;
else module.exports.getPrototypeOf = function _getPrototypeOf(o) {
	return o.__proto__ || Object.getPrototypeOf(o);
}

module.exports.inherits = function _inherits(subClass, superClass) {
	if (typeof superClass !== 'function' && superClass !== null) {
		throw new TypeError("Super expression must be either null or a function");
	}
	subClass.prototype = Object.create(superClass && superClass.prototype, {
		constructor: {
			value: subClass,
			writable: true,
			configurable: true
		}
	});
	if (superClass) module.exports.setPrototypeOf(subClass, superClass);
}

module.exports.setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf : function _setPrototypeOf(o, p) {
	o.__proto__ = p;
	return o;
}

module.exports.instanceof = function _instanceof(left, right) {
	if (right != null && typeof Symbol != 'undefined' && right[Symbol.hasInstance]) return right[Symbol.hasInstance](left);
	else return left instanceof right;
}

module.exports.classCallCheck = function(instance, Constructor) {
	if (!module.exports.instanceof(instance, Constructor)) {
		throw new TypeError("Cannot call a class as a function");
	}
}

module.exports.defineProperties = function(target, props) {
	for (var i = 0; i < props.length; i++) {
		var descriptor = props[i];
		descriptor.enumerable = descriptor.enumerable || false;
		descriptor.configurable = true;
		if ('value' in descriptor) descriptor.writable = true;
		Object.defineProperty(target, descriptor.key, descriptor);
	}
}

module.exports.createClass = function(Constructor, protoProps, staticProps) {
	if (protoProps) module.exports.defineProperties(Constructor.prototype, protoProps);
	if (staticProps) module.exports.defineProperties(Constructor, staticProps);
	return Constructor;
}

module.exports.objectSpread = function(target) {
	for (var i = 1; i < arguments.length; i++) {
		var source = arguments[i] != null ? arguments[i] : {};
		var ownKeys = Object.keys(source);
		if (typeof Object.getOwnPropertySymbols == 'function')
			ownKeys = ownKeys.concat(
				Object.getOwnPropertySymbols(source).filter(
					function(sym) {
						return Object.getOwnPropertyDescriptor(source, sym).enumerable
					}
				)
			);

		for (var j = 0; j < ownKeys.length; j++) {
			module.exports.defineProperty(target, ownKeys[j], source[ownKeys[j]]);
		}
	}

	return target;
}

module.exports.initializerDefineProperty = function(target, property, descriptor, context) {
	if (!descriptor) return;
	Object.defineProperty(target, property, {
		enumerable: descriptor.enumerable,
		configurable: descriptor.configurable,
		writable: descriptor.writable,
		value: descriptor.initializer ? descriptor.initializer.call(context) : null
	});
}

module.exports.applyDecoratedDescriptor = function(target, property, decorators, descriptor, context) {
	var desc = {};
	Object['ke' + 'ys'](descriptor).forEach(function(key) {
		desc[key] = descriptor[key];
	});
	desc.enumerable = !!desc.enumerable;
	desc.configurable = !!desc.configurable;
	if ('value' in desc || desc.initializer) {
		desc.writable = true;
	}
	desc = decorators.slice().reverse().reduce(function(desc, decorator) {
		return decorator(target, property, desc) || desc;
	}, desc);

	if (context && desc.initializer !== void 0) {
		desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
		desc.initializer = void 0;
	}
	if (desc.initializer === void 0) {
		Object['define' + 'Property'](target, property, desc);
		desc = null;
	}
	return desc;
}

module.exports.initializerWarningHelper = function(descriptor, context) {
	throw new Error("Decorating class property failed. Please ensure that 'proposal-class-properties' is enabled and set to use loose mode. To use proposal-class-properties in spec mode with decorators, wait for the next major version of decorators in stage 2.");
}

module.exports.interopRequireWildcard = function(obj) {
	if (obj && obj.__esModule) return obj;
	var newObj = {};
	if (obj != null) {
		for (var key in obj) {
			if (Object.prototype.hasOwnProperty.call(obj, key)) {
				var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
				if (desc.get || desc.set) Object.defineProperty(newObj, key, desc);
				else newObj[key] = obj[key];
			}
		}
	}
	newObj.default = obj;
	return newObj;
}

module.exports.arrayWithHoles = function(obj) {
	if (Array.isArray(obj)) return obj;
}

module.exports.iterableToArrayLimit = function(arr, i) {
	var _arr = [];
	var _n = true;
	var _d = false;
	var _e = undefined;
	try {
		for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
			_arr.push(_s.value);
			if (_i && _arr.length == i) break;
		}
	} catch (err) {
		_d = true;
		_e = err;
	} finally {
		try {
			if (!_n && _i['return'] != null) _i['return']();
		} finally {
			if (_d) throw _e;
		}
	}
	return _arr;
}

module.exports.nonIterableRest = function() {
	throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

module.exports.slicedToArray = function(arr, i) {
	return module.exports.arrayWithHoles(arr) || module.exports.iterableToArrayLimit(arr, i) || module.exports.nonIterableRest();
}

module.exports.isNativeFunction = function(fn) {
	return Function.toString.call(fn).indexOf('[native code]') !== -1;
}

module.exports.isNativeReflectConstruct = function() {
	var r = function() {
		if (typeof Reflect === "undefined" || !Reflect.construct) return false;
		if (Reflect.construct.sham) return false;
		if (typeof Proxy === "function") return true;
		try {
			Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
			return true;
		} catch (e) {
			return false;
		}
	}
	var rv = r();
	module.exports.isNativeReflectConstruct = function() {
		return rv;
	}
	return rv;
}

if (module.exports.isNativeReflectConstruct()) {
	module.exports.construct = Reflect.construct;
} else {
	module.exports.construct = function(Parent, args, Class) {
		var a = [null];
		a.push.apply(a, args);
		var Constructor = Function.bind.apply(Parent, a);
		var instance = new Constructor();
		if (Class) {
			module.exports.setPrototypeOf(instance, Class.prototype);
		}
		return instance;
	}
}

var _cache = typeof Map === 'function' ? new Map() : undefined;
module.exports.wrapNativeSuper = function(Class) {
	if (Class === null || !module.exports.isNativeFunction(Class)) return Class;
	if (typeof Class !== "function") {
		throw new TypeError("Super expression must be null or a function");
	}
	if (typeof _cache != "undefined") {
		if (_cache.has(Class)) return _cache.get(Class);
		_cache.set(Class, Wrapper);
	}
	function Wrapper() {
		return module.exports.construct(Class, arguments, _getPrototypeOf(this).constructor);
	}
	Wrapper.prototype = Object.create(
		Class.prototype, 
		{
			constructor: {
				value: Wrapper,
				enumerable: false,
				configurable: true,
				writable: true
			}
		}
	);
	return module.exports.setPrototypeOf(Wrapper, Class);
}

module.exports.objectWithoutPropertiesLoose = function(source, excluded) {
	if (source == null) return {};
	var target = {};
	var sourceKeys = Object.keys(source), key, i;
	for (i = 0; i < sourceKeys.length; i++) {
		key = sourceKeys[i];
		if (excluded.indexOf(key) >= 0) {
			continue;
		}
		target[key] = source[key];
	}
	return target;
}

module.exports.objectWithoutProperties = function(source, excluded) {
	if (source == null) return {};
	var target = module.exports.objectWithoutPropertiesLoose(source, excluded);
	var key, i;
	if (Object.getOwnPropertySymbols) {
		var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
		for (i = 0; i < sourceSymbolKeys.length; i++) {
			key = sourceSymbolKeys[i];
			if (excluded.indexOf(key) >= 0) continue;
			if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
			target[key] = source[key];
		}
	}
	return target;
}

module.exports.arrayWithoutHoles = function(arr) {
	if (Array.isArray(arr)) {
		for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
			arr2[i] = arr[i];
		}
		return arr2;
	}
}

module.exports.iterableToArray = function(iter) {
	if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === '[object Arguments]')
		return Array.from(iter);
}

module.exports.nonIterableSpread = function() {
	throw new TypeError("Invalid attempt to spread non-iterable instance");
}

module.exports.toConsumableArray = function(arr) {
	return module.exports.arrayWithoutHoles(arr) || module.exports.iterableToArray(arr) || module.exports.nonIterableSpread();
}

module.exports.toArray = function(arr) {
	return module.exports.arrayWithHoles(arr) || module.exports.iterableToArray(arr) || module.exports.nonIterableRest();
}

module.exports.defineEnumerableProperties = function(obj, descs) {
    for (var key in descs) {
        var desc = descs[key];
        desc.configurable = desc.enumerable = true;
        if ("value" in desc) desc.writable = true;
        Object.defineProperty(obj, key, desc);
    }
    if (Object.getOwnPropertySymbols) {
        var objectSymbols = Object.getOwnPropertySymbols(descs);
        for (var i = 0; i < objectSymbols.length; i++) {
            var sym = objectSymbols[i];
            var desc = descs[sym];
            desc.configurable = desc.enumerable = true;
            if ("value" in desc) desc.writable = true;
            Object.defineProperty(obj, sym, desc);
        }
    }
    return obj;
}

module.exports.extends = Object.assign || function(target) {
	for (var i = 1; i < arguments.length; i++) {
		var source = arguments[i];
		for (var key in source) {
			if (Object.prototype.hasOwnProperty.call(source, key))
				target[key] = source[key];
		}
	}
	return target;
}

